import { render } from "./DataHealthBanner.vue?vue&type=template&id=79936c9c&scoped=true"
import script from "./DataHealthBanner.vue?vue&type=script&lang=js"
export * from "./DataHealthBanner.vue?vue&type=script&lang=js"

import "./DataHealthBanner.vue?vue&type=style&index=0&id=79936c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79936c9c"]])

export default __exports__